import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'filterAlarmBySelectedTrain'
})
export class FilterAlarmBySelectedTrain implements PipeTransform {

  transform(alarms: MonitoringAlarm[], selectedAlarmList: MonitoringAlarm[]): MonitoringAlarm[] {

    return selectedAlarmList && selectedAlarmList.length > 0 ? alarms.filter(alarm => selectedAlarmList[0].projectId === alarm.projectId && selectedAlarmList[0].trainId === alarm.trainId) : alarms;

  }

}
